<template>
  <div class="content-input">
    <div class="input-title">
      <label>{{ component.label }}</label>
      <label v-if="isRequired()" style="color: #10dd2c"> *</label>
    </div>

    <template>
      <input
        v-if="isEditable()"
        :placeholder="component.placeholder"
        class="input"
      />
      <input
        v-else
        :placeholder="isIncrementBy() ? '0' : component.placeholder"
        class="input-disabled"
      />
    </template>
  </div>
</template>
<script>
export default {
  name: 'InputText',

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  methods: {
    isEditable() {
      const editableRuleExists = this.component.rules.some(rule => {
        return rule.key === 'editable'
      })

      if (!editableRuleExists) {
        return true
      }

      return this.component.rules.some(rule => {
        return rule.key === 'editable' && rule.value === true
      })
    },

    isIncrementBy() {
      return this.component?.functions?.some(rule => {
        return rule.key === 'incrementBy'
      })
    },

    isRequired() {
      return this.component.rules.some(rule => {
        return (
          rule.key === 'required' &&
          (rule.value === true || rule.value === 'true')
        )
      })
    },
  },
}
</script>
<style scoped>
.content-input {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.input-title {
  font-weight: bold;
  /* font-size: 14px; */
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 5px;
}
.input {
  background-color: #eeeeee;
  border: 1px solid #dddddd;
  border-radius: 8px;
  color: #69739e;
  padding: 10px;
}
.input-disabled {
  background-color: #dddddd;
  border: 1px solid #dddddd;
  border-radius: 8px;
  color: #69739e;
  padding: 10px;
}
input::placeholder {
  color: #69739e;
}
input:focus {
  outline: none;
  box-shadow: none;
}
</style>
